import { render, staticRenderFns } from "./categoryTable.vue?vue&type=template&id=900d21b2&scoped=true"
import script from "./categoryTable.vue?vue&type=script&lang=js"
export * from "./categoryTable.vue?vue&type=script&lang=js"
import style0 from "./categoryTable.vue?vue&type=style&index=0&id=900d21b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900d21b2",
  null
  
)

export default component.exports